// src/services/apiClient.js
import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://rwa.navaantrix.com",
});

// ✅ Request interceptor
apiClient.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// ✅ Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
   
    return Promise.reject(error);
  }
);

export default apiClient;
